export const DefaultFields = [
  "firstName",
  "lastName",
  "email",
  "phone",
  "countryCode",
  "zip",
  "terms",
  "sms",
  "customTerms",
  "customAgreement",
] as const;

export type DefaultField = (typeof DefaultFields)[number];

export const DefaultCheckboxFields: DefaultField[] = [
  "terms",
  "sms",
  "customTerms",
  "customAgreement",
];
